<template>
  <v-container fill-height fluid grid-list-xl>
    <material-card
      color="green"
      flat
      full-width
      title="Подписчики"
    >
      <v-data-table
        :loading="$apollo.loading"
        loading-text="Загрузка..."
        :headers="headers"
        :items="data"
        :server-items-length="totalCount"
        :options.sync="options"
      >
        <template #top>
          <a href="#" onclick="return false" @click="exportOrders" style="margin-left: 20px;">Экспорт</a>
          <v-progress-circular
            v-if="exportLoadingVisible"
            indeterminate
            :size="15"
            color="primary"
            :width="2"
          ></v-progress-circular>
        </template>
        <template #item.actions="{ item }">
          <div class="d-flex">
            <v-dialog
              transition="dialog-bottom-transition"
              width="500"
              :value="deleteDialog === item.id"
              @input="toggleDeleteDialog($event, item.id)"
            >
              <template #activator="{ on, attrs }">
                <v-tooltip top>
                  <template #activator="{ on: tooltipActions, attrs: tooltipAttrs }">
                    <span v-bind="tooltipAttrs" v-on="tooltipActions">
                      <v-icon tag="i" v-bind="attrs" small class="mr-2" v-on="on">
                        mdi-delete
                      </v-icon>
                    </span>
                  </template>
                  Удалить
                </v-tooltip>
              </template>
              <v-card>
                <v-toolbar color="primary" dark class="text-center mb-6">
                  Подтвердите Действие
                </v-toolbar>
                <v-card-text>
                  Вы точно хотите удалить подписчика"?
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn color="tertiary" dark @click="deleteDialog = null">
                    Отменить
                  </v-btn>
                  <v-btn color="primary" @click="deleteSubscription(item.id)">
                    Удалить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>

<script>
import { deleteSubscription, exportSubscriptions, getSubscriptions } from '@/graphql/subscriptions'
import { startCase } from 'lodash-es'
import { downloadFile } from '@/components/core/fileUtils'

export default {
  name: 'Subscriptions',
  layout: 'dashboard',
  apollo: {
    subscriptions: {
      query: getSubscriptions,
      update (data) {
        return data?.subscriptions?.data
      },
      result ({ data }) {
        if (data?.subscriptions?.data) {
          this.data = data.subscriptions.data
          this.totalCount = data.subscriptions.totalCount
        }
      }
    }
  },
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        multiSort: false
      },
      data: [],
      totalCount: 0,
      deleteDialog: false,
      dialog: false,
      exportLoadingVisible: false,
      headers: [
        ['id', 'Id'],
        ['email', 'Email'],
        ['subscribe_confirmed_at', 'Дата подписки'],
        ['actions', null]
      ]
          .map((colTitle) => {
            const [value, text] = Array.isArray(colTitle)
                ? colTitle
                : [colTitle, startCase(colTitle)]

            return {
              value,
              text,
              sortable: false
            }
          })
    }
  },
  methods: {
    deleteSubscription (id) {
      this.$apollo
          .mutate({
            mutation: deleteSubscription,
            variables: {
              id
            }
          })
          .then((data) => {
            this.$apollo.queries.subscriptions.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
    },
    toggleDeleteDialog (value, slug) {
      this.deleteDialog = value
          ? slug
          : null
    },
    exportOrders () {
      this.exportLoadingVisible = true
      this.$apollo
          .mutate({
            mutation: exportSubscriptions
          })
          .then((data) => {
            downloadFile('subscriptions.csv', data?.data?.exportSubscriptions)
            this.exportLoadingVisible = false
          })
          .catch((error) => {
            console.error(error)
            this.exportLoadingVisible = false
          })

      return false
    }
  }
}
</script>

<style scoped>

</style>
